module.exports = __webpack_public_path__ + "media/images/svgs/size_guide_ruler-a3f1c13868a9e6810e240a381b590d0c.svg";